/**
 * Labstep
 *
 * @module components/EntityStateWorkflow/Modal/RightPanel
 * @desc Right panel of the entity state workflow modal
 */

import { EntityStateWorkflowModalGeneralSettings as GeneralSettings } from 'labstep-web/components/EntityStateWorkflow/Modal/GeneralSettings';
import { EntityStateWorkflowModalRolesAndSignatures as RolesAndSignatures } from 'labstep-web/components/EntityStateWorkflow/Modal/RolesAndSignatures';
import { Flex } from 'labstep-web/core/Flex';
import type React from 'react';
import type { EntityStateWorkflowModalRightPanelProps } from './types';

export const EntityStateWorkflowModalRightPanel: React.FC<
  EntityStateWorkflowModalRightPanelProps
> = ({ entityState, entityStateWorkflow }) => (
  <Flex column style={{ gap: '20px' }}>
    <GeneralSettings entityState={entityState} />
    <RolesAndSignatures
      entityStateWorkflow={entityStateWorkflow}
      entityState={entityState}
    />
  </Flex>
);
